import { IOnboardingComponentProps } from "pages/onboarding/[[...step]]";
import { OtpForm } from "@components/auth/components/OtpForm";

export const CodeStep = ({
  nextStep,
  email = "",
  name,
  handleSaveAnswer: _handleSaveAnswer,
}: IOnboardingComponentProps) => {
  return (
    <OtpForm
      email={email}
      name={name}
      onSuccess={() => {
        nextStep();
      }}
    />
  );
};
